import {Controller, useForm} from "react-hook-form";
import { useEffect } from "react";
import Poster from "../../display/serials/Poster";

export function EditSerial(props) {
    const serial = props.serial ?? {
        name: '',
        nameOriginal: '',
        season: 'сезон 1',
        year: new Date().getFullYear(),
        description: '',
        posterUrl: '',
        placeholderPosterUrl: '',
        downloadUrl: 'https://toloka.to/t',
        isActive: true,
        isOngoing: false
    };

    const { register, handleSubmit, watch, reset, control } = useForm({
        defaultValues: serial
    });

    useEffect(() => {
        reset(serial);
    }, [props.serial, reset]);

    const ToggleField = ({ value, onChange, label, color }) => (
        <div onClick={() => onChange(!value)} style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }}>
            <div style={{
                width: '36px', height: '18px', backgroundColor: value ? color : '#d1d5db',
                borderRadius: '20px', position: 'relative', transition: '0.3s'
            }}>
                <div style={{
                    width: '14px', height: '14px', backgroundColor: '#fff', borderRadius: '50%',
                    position: 'absolute', top: '2px', left: value ? '20px' : '2px', transition: '0.3s'
                }} />
            </div>
            <span style={{ fontSize: '13px', fontWeight: '600', color: '#374151' }}>{label}</span>
        </div>
    );

    const labelStyle = {
        display: 'block',
        marginBottom: '5px',
        fontWeight: '600',
        fontSize: '14px',
        color: '#4b5563'
    };

    const inputStyle = {
        width: '100%',
        padding: '10px',
        borderRadius: '8px',
        border: '1px solid #d1d5db',
        marginBottom: '15px',
        outline: 'none',
        boxSizing: 'border-box'
    };

    return (
        <div style={{ padding: '10px' }}>
            <form onSubmit={handleSubmit(props.onSaveClicked)}>
                <div style={{ display: 'grid', gridTemplateColumns: '1.5fr 1fr', gap: '30px' }}>
                    <div>
                        <div style={{ display: 'flex', gap: '20px', padding: '15px', backgroundColor: '#f9fafb', borderRadius: '10px', marginBottom: '20px', border: '1px solid #eee' }}>
                            <Controller
                                name="isActive"
                                control={control}
                                render={({ field }) => (
                                    <ToggleField label={field.value ? "В роботі" : "Завершено"} value={field.value} onChange={field.onChange} color="#10b981" />
                                )}
                            />
                            <div style={{ width: '1px', backgroundColor: '#e5e7eb' }} />
                            <Controller
                                name="isOngoing"
                                control={control}
                                render={({ field }) => (
                                    <ToggleField label={field.value ? "Онґоінґ" : "Старий"} value={field.value} onChange={field.onChange} color="#3b82f6" />
                                )}
                            />
                        </div>

                        <label style={{fontWeight: '600', fontSize: '14px'}}>Тип контенту</label>                        <select {...register('type')} style={inputStyle}>
                            <option value="1">Багатосерійка</option>
                            <option value="2">Фільм</option>
                        </select>

                        <label style={labelStyle}>Назва (UA)</label>
                        <input {...register('name')} style={inputStyle} placeholder="Назва українською..." />

                        <label style={labelStyle}>Оригінальна назва</label>
                        <input {...register('nameOriginal')} style={inputStyle} placeholder="Original Title..." />

                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
                            <div>
                                <label style={labelStyle}>Сезон</label>
                                <input {...register('season')} style={inputStyle} />
                            </div>
                            <div>
                                <label style={labelStyle}>Рік</label>
                                <input {...register('year')} type="number" style={inputStyle} />
                            </div>
                        </div>

                        <label style={labelStyle}>Опис</label>
                        <textarea {...register('description')} style={{ ...inputStyle, minHeight: '200px', resize: 'vertical', fontFamily: 'inherit', fontSize: 'inherit' }} />

                        <label style={labelStyle}>Лінк на Toloka/Download</label>
                        <input {...register('downloadUrl')} style={inputStyle} />
                    </div>

                    {/* Right: media, posters */}
                    <div style={{ backgroundColor: '#f9fafb', padding: '20px', borderRadius: '12px', border: '1px dashed #d1d5db', display: 'flex', flexDirection: 'column', gap: '15px' }}>

                        {/* Main poster */}
                        <div>
                            <label style={labelStyle}>URL основного постера</label>
                            <input {...register('posterUrl')} style={inputStyle} placeholder="https://..." />
                            <div style={{ marginTop: '10px', display: 'flex', justifyContent: 'center' }}>
                                <div style={{ width: '100%', maxWidth: '250px' }}> {/* Обмежуємо основний, щоб не був на весь екран */}
                                    <Poster link={watch('posterUrl')} />
                                </div>
                            </div>
                        </div>

                        <hr style={{ width: '100%', border: '0', borderTop: '1px solid #e5e7eb', margin: '10px 0' }} />

                        {/* Mini poster */}
                        <div>
                            <label style={labelStyle}>URL маленького постера (placeholder)</label>
                            <input {...register('placeholderPosterUrl')} style={inputStyle} placeholder="https://..." />

                            <div style={{
                                marginTop: '10px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '15px',
                                padding: '10px',
                                backgroundColor: '#fff',
                                borderRadius: '8px',
                                border: '1px solid #e5e7eb'
                            }}>
                                <div style={{ width: '80px', flexShrink: 0 }}>
                                    <Poster link={watch('placeholderPosterUrl')} />
                                </div>
                                <div style={{ fontSize: '12px', color: '#6b7280' }}>
                                    <p style={{ margin: 0 }}><b>Прев'ю плейсхолдера</b></p>
                                    <p style={{ margin: 0 }}>Ця картинка завантажується першою для економії трафіку.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderTop: '1px solid #eee', paddingTop: '20px' }}>
                    {serial.id ? (
                        <button
                            type="button"
                            onClick={() => props.onDeleteClicked(serial)}
                            style={{ padding: '10px 20px', color: '#ef4444', backgroundColor: 'transparent', border: 'none', cursor: 'pointer', fontWeight: '600' }}
                        >
                            🗑️ Видалити аніме
                        </button>
                    ) : <div></div>}

                    <button
                        type="submit"
                        style={{
                            padding: '12px 40px',
                            backgroundColor: '#4f46e5',
                            color: 'white',
                            border: 'none',
                            borderRadius: '8px',
                            fontWeight: 'bold',
                            cursor: 'pointer',
                            boxShadow: '0 4px 6px rgba(79, 70, 229, 0.3)'
                        }}
                    >
                        Зберегти зміни
                    </button>
                </div>
            </form>
        </div>
    );
}